// resources/js/store/modules/meetings.js
import axios from "axios";

const state = () => ({
  meetings: [],
  loading: false,
  error: null,
});

const mutations = {
  SET_MEETINGS(state, meetings) {
    state.meetings = meetings || [];
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  /**
   * GET /api/meetings
   * Загружаем список собраний для левой колонки
   */
  async fetchMeetings({ commit }) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        "https://apidash.smartpress.kz/api/meetings",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      commit("SET_MEETINGS", response.data.meetings || []);
      return response.data;
    } catch (error) {
      console.error("Error fetching meetings:", error);
      commit("SET_ERROR", error);
      commit("SET_MEETINGS", []);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  /**
   * GET /api/meetings/{id}/agenda
   * Загружаем повестку конкретного собрания
   * Ожидаемый backend-ответ:
   * { meeting: {...}, agenda_items: [...] }
   */
  async fetchAgenda(_, meetingId) {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `https://apidash.smartpress.kz/api/meetings/${meetingId}/agenda`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching meeting agenda:", error);
      throw error;
    }
  },

  /**
   * (опционально) POST /api/meetings
   * Если захотите вытащить создание встречи в стор
   */
  async createMeeting({ dispatch }, payload) {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        "https://apidash.smartpress.kz/api/meetings",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // после создания перезагрузим список
      await dispatch("fetchMeetings");

      return response.data;
    } catch (error) {
      console.error("Error creating meeting:", error);
      throw error;
    }
  },
};

const getters = {
  // список всех собраний
  all(state) {
    return state.meetings;
  },
  // если нужно потом
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
